<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (isCurrentUser()) {
<mat-chip-set>
  <mat-chip highlighted color="primary">You</mat-chip>
</mat-chip-set>
}
